/**
 * CircularProgress - MUI CircularProgress Component Wrapper
 * 
 * A thin wrapper around Material-UI CircularProgress component for consistent imports.
 */

import MuiCircularProgress from "@mui/material/CircularProgress";

const CircularProgress = (props) => {
  return <MuiCircularProgress {...props} />;
};

export default CircularProgress;

